import UploadNewsForm from "../../UploadNewsForm";
import { createParishNews } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewParishNews() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createParishNews(title, description, image);
      if (result) {
        navigate("/parish-news/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Parish News"}
          breadCrumbText={"Create New"}
          goBackLink={"/parish-news/all"}
        />
      </Container>
    </>
  );
}
